import { Button } from "primereact/button";
import { differenceInCalendarDays } from 'date-fns';
import { ExportarExcel } from "./ExportarExcel";
import XLSX from "xlsx-color";
import { saveAs } from "file-saver";
import { Dialog } from "primereact/dialog";
import { Timeline } from "primereact/timeline";
import { isValidElement, Children, cloneElement } from "react";
import { isValidPhoneNumber } from 'libphonenumber-js';

export const renderPanelHeader = (numero, titulo, icono) => {
    return (
        <div className="flex align-items-center justify-content-between w-full" style={{ margin: '-4px 0' }}>
            <div className="flex align-items-center gap-2">
                {numero && (
                    <div className="flex align-items-center justify-content-center bg-white text-primary font-bold border-circle"
                        style={{ width: '24px', height: '24px', minWidth: '24px', fontSize: '0.8rem' }}>
                        {numero}
                    </div>
                )}
                <span className="text-white font-bold text-base uppercase">
                    {titulo}
                </span>
            </div>
            <i className={`${icono} text-white text-lg ml-3`} />
        </div>
    );
};

export const renderDialogInstruccion = (visible, setVisible, title, content) => {

    const headerContent = (
        <div className="flex align-items-center gap-2">
            <i className="pi pi-info-circle text-white text-2xl" />
            <span className="font-bold text-xl text-white">{title}</span>
        </div>
    );

    const footerContent = (
        <div className="flex justify-content-end w-full pt-2">
            <Button label="Continuar" icon="pi pi-check" onClick={() => setVisible(false)} className="p-button-outlined p-button-primary border-round-xl" />
        </div>
    );

    // Función recursiva que transforma listas HTML a Timeline
    const transformListsToTimeline = (node, index = 0) => {
        if (Array.isArray(node)) {
            return node.map((n, i) => transformListsToTimeline(n, i));
        }
        if (!isValidElement(node)) {
            return node;
        }
        if (node.type === 'ol' || node.type === 'ul') {
            const items = Children.toArray(node.props.children).filter(child => isValidElement(child) && child.type === 'li').map(child => child.props.children);

            return (
                <Timeline key={`timeline-${index}`} value={items} align="left" className="w-full mt-3 p-0"
                    pt={{ opposite: { className: 'hidden' }, content: { className: 'pl-3' } }}
                    content={(item, i) => (
                        <div className="mb-4 text-left">
                            <span className="text-500 font-semibold block mb-1">Paso {i + 1}</span>
                            <span className="font-bold text-800 line-height-3">{item}</span>
                        </div>
                    )}
                />
            );
        }
        if (node.props && node.props.children) {
            return cloneElement(
                node,
                { key: `node-${index}` },
                transformListsToTimeline(node.props.children)
            );
        }
        return node;
    };

    const contenidoTransformado = transformListsToTimeline(content);

    return (
        <Dialog visible={visible} style={{ width: '600px' }} breakpoints={{ '960px': '75vw', '641px': '95vw' }} header={headerContent} footer={footerContent}
            modal onHide={() => setVisible(false)} className="p-fluid shadow-6"
            pt={{ header: { className: 'bg-blue-600 pb-3' }, closeButtonIcon: { className: 'text-white' } }} contentStyle={{ paddingBottom: '0.5rem', paddingTop: '1.5rem' }}>
            <div className="m-0 px-1">
                {contenidoTransformado}
            </div>
        </Dialog>
    );
};

export const buttonsForms = (hideDialog, load = false) => {
    return (
        <>
            <div className="formgrid grid">
                <div className="field col">
                    <Button label="Guardar" style={{ maxWidth: '120px', float: 'right' }} type="submit" icon="pi pi-save" className="p-button-warning" loading={load} />
                </div>
                <div className="field col">
                    <Button label="Cancelar" style={{ maxWidth: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={() => hideDialog(false)} disabled={load} />
                </div>
            </div>
        </>
    );
}

export const leftToolbarTemplate = (openNew, label, permss) => {
    return (
        <>
            <div className="my-2">
                <Button label={label} icon="pi pi-plus" className="p-button-success mr-2" type="button" tooltip="Nuevo Registro" tooltipOptions={{ position: 'top' }} onClick={openNew} style={{ display: permss?.crear ? 'block' : 'none' }} />
            </div>
        </>
    );
};

export const rightToolbarTemplate = (items, omodel, titleExcel, titlePdf, mostrarBotonExtra = false, url = '', diasMaxDescargaReporte = 0) => {
    const tieneElementos = Array.isArray(items) && items.length > 0;
    const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const estados = [{ nombre: 'Activo', cat_id: true }, { nombre: 'Inactivo', cat_id: false }];

    const formatEstado = (estado) => {
        if (typeof estado === "string") return estado;
        // Extrae el valor a comparar dependiendo de si viene un objeto o un valor directo
        const valorBuscado = (estado !== null && typeof estado === "object") ? estado.cat_id : estado;
        const encontrado = estados.find(st => st.cat_id === valorBuscado);
        return encontrado ? encontrado.nombre : (valorBuscado ? 'Activo' : 'Inactivo');
    };

    const columnsExport = (model) => Object.entries(model.model).filter(([_, col]) => col.export).map(([key, col]) => ({ title: col.header, dataKey: key }));

    const colsReportExcel = (model) => Object.values(model.model).filter(col => col.export).map(col => col.header);

    const dataReportExcel = (data, model) =>
        data.map(val => {
            const item = {};
            Object.entries(model.model).forEach(([key, spec]) => {
                if (spec.export) {
                    let valor = val[key];
                    if (spec.sino !== undefined) {
                        valor = valor ? 'Si' : 'No';
                    } else if (key === 'estado') {
                        valor = formatEstado(valor);
                    } else if (valor == null) { // "== null" atrapa tanto null como undefined
                        valor = '';
                    }
                    item[spec.header] = valor;
                }
            });
            return item;
        });

    const cambiarLabelEstado = (data) =>
        data.map(item => ({ ...item, estado: item.estado !== undefined ? formatEstado(item.estado) : item.estado }));

    const exportExcel = (fileName, items, model) => {
        const data = dataReportExcel(items, model);
        const ws = XLSX.utils.json_to_sheet(data);
        const cols = colsReportExcel(model);
        const range = ws['!ref'] ? XLSX.utils.decode_range(ws['!ref']) : { s: { r: 0, c: 0 }, e: { r: 0, c: cols.length - 1 } };

        range.e.c = Math.max(range.e.c, cols.length - 1);
        ws['!ref'] = XLSX.utils.encode_range(range);

        const borderStyle = { style: "thin", color: { rgb: "000000" } };

        cols.forEach((headerText, index) => {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
            if (!ws[cellRef]) ws[cellRef] = { t: 's', v: headerText || '' };

            ws[cellRef].s = {
                fill: { patternType: "solid", fgColor: { rgb: "DADADA" } },
                font: { name: "Calibri", sz: 13, color: { rgb: "000000" }, bold: true },
                alignment: { horizontal: "center", vertical: "center" },
                border: { top: borderStyle, bottom: borderStyle, left: borderStyle, right: borderStyle }
            };
        });

        ws["!cols"] = Array(cols.length).fill({ width: 30 });

        const wb = { Sheets: { data: ws }, SheetNames: ["data"], Workbook: { Views: [{ RTL: false }] } };
        const eb = XLSX.write(wb, { bookType: "xlsx", type: "array", cellStyles: true });
        saveAs(new Blob([eb], { type: EXCEL_TYPE }), fileName + EXCEL_EXTENSION);
    };

    const exportPdf = (fileName, model, items, title) => {
        const exportColumns = columnsExport(model);
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                doc.autoTable({
                    columns: exportColumns,
                    margin: { top: 35 },
                    body: items,
                    didDrawPage: () => doc.text(title, 20, 30)
                });
                doc.save(fileName);
            });
        });
    };

    return (
        <>
            {mostrarBotonExtra && (
                <ExportarExcel title={titleExcel} url={url} diasMaxDescargaReporte={diasMaxDescargaReporte} />
            )}
            <Button onClick={() => tieneElementos && exportExcel(titleExcel, items, omodel)} className="p-button-success mr-2" type="button" tooltip="Exportar a Excel" icon="pi pi-file-excel" tooltipOptions={{ position: 'left' }} />
            <Button onClick={() => tieneElementos && exportPdf('Listado.pdf', omodel, cambiarLabelEstado(items), titlePdf)} className="p-button-warning mr-2" type="button" tooltip="Exportar a PDF" icon="pi pi-file-pdf" tooltipOptions={{ position: 'left' }} />
        </>
    );
};

export const funcMessageBlobError = async (title, error, toast) => {
    try {
        let message = error.response.data.message;
        if (!message) {
            const responseObj = await error.response.data.text();
            error.response.data = JSON.parse(responseObj);
            message = error.response.data.message;
        }
        toast.current.show({ severity: 'error', summary: title, detail: message, life: 3000 });
    } catch (error) {
        toast.current.show({ severity: 'error', summary: title, detail: 'Corrija los errores.', life: 3000 });
    }
}

export const funcSistemaError = (error, toast) => {
    try {
        let msg = error?.response?.data?.message;
        const detail = msg || 'Ocurrió un error al procesar la solicitud.';
        toast.current.show({ severity: 'error', summary: 'Error', detail: detail, life: 3000 });
    } catch (e) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error crítico al procesar la solicitud.', life: 3000 });
    }
}

export const funcDeleteError = (error, toast) => {
    try {
        toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 });
    } catch (error) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al eliminar la información.', life: 3000 });
    }
}

export const funcError = (error, toast, setError) => {
    try {
        const errs = error.response.data.errors;
        Object.keys(errs).map((key) => {
            let ikey = key;
            if (key.indexOf('.') >= 0) {
                ikey = key.split('.');
                ikey = ikey[0];
            }
            setError(ikey, { type: 'custom', message: errs[key] });
            return 1;
        });
    } catch (error) { }

    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Corrija los errores para guardar la información.', life: 3000 });
}

export const funcErrorHibrida = (error, toast, setError) => {
    let mensajePrincipal = 'Corrija los errores para guardar la información.';
    let detallesErrores = [];

    try {
        const responseData = error.response?.data;
        // Setear errores en los inputs
        if (responseData?.errors) {
            const errs = responseData.errors;
            Object.keys(errs).forEach((key) => {
                let ikey = key.includes('.') ? key.split('.')[0] : key;
                setError(ikey, { type: 'custom', message: errs[key] });
            });
        }
        // Mensaje principal
        if (responseData?.message) {
            mensajePrincipal = responseData.message;
        }
        // Detalles en el array
        if (responseData?.data && Array.isArray(responseData.data) && responseData.data.length > 0) {
            detallesErrores = responseData.data;
        }
    } catch (e) {
        // console.error(e);
    }

    const contenidoToast = (
        <div style={{ width: '100%' }}>
            <span style={{ fontWeight: detallesErrores.length > 0 ? '600' : 'normal' }}>
                {mensajePrincipal}
            </span>
            {detallesErrores.length > 0 && (
                <div style={{ marginTop: '0.5rem', fontSize: '0.9em' }}>
                    <span style={{ textDecoration: 'underline' }}>Detalles:</span>
                    <ul style={{ margin: '0.25rem 0 0 0', paddingLeft: '1.2rem' }}>
                        {detallesErrores.map((detalle, index) => (
                            <li key={index} style={{ marginBottom: '0.25rem' }}>
                                {detalle}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
    toast.current.show({ severity: 'error', summary: 'Error', detail: contenidoToast, life: detallesErrores.length > 0 ? 5000 : 3000 });
}

export const funDefault = (model) => {
    let values = {};
    Object.keys(model).map((key) => {
        if (model[key].value !== undefined) {
            values[key] = model[key].value;
        }
        return 1;
    });

    return values;
}

export const getFormErrorMessage = (errors, name) => {
    return errors[name] && <small className="p-error"><br />{errors[name].message}</small>
};

export const paramLazy = () => {
    const params = {
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null
    }

    return params;
}

export const funcSuccess = (res, toast) => {
    try {
        toast.current.show({ severity: 'success', summary: 'Exitoso', detail: res.message, life: 3000 });
    } catch (error) {
        toast.current.show({ severity: 'success', summary: 'Exitoso', detail: 'Información registrada correctamente.', life: 3000 });
    }
}

export const renewValues = (values, model) => {
    const newValues = { ...values };

    Object.keys(model).forEach((key) => {
        // Si el valor recibido es nulo o indefinido, toma el valor definido en el modelo
        if (newValues[key] === null || newValues[key] === undefined) {
            newValues[key] = model[key]?.value ?? null;
        }
    });

    return newValues;
};

export const buttonsFormsReports = (hideDialog, generarReporte, subirReporte, enviar, loading, habilitar = false, cancelar = true, siSaveBtn = true) => {
    return (
        <div className="formgrid grid">
            <div className="field col-12" style={{ textAlign: 'center' }}>
                {siSaveBtn && <><Button label="Guardar" loading={loading} disabled={loading} type="submit" icon="pi pi-save" className="p-button-warning"
                    title="Guardar" />&nbsp;</>}
                {habilitar && <><Button label="Formulario" icon="pi pi-print" type="button" className="p-button-warning" onClick={() => generarReporte()}
                    loading={loading} disabled={loading} title="Generar Formulario en PDF" />&nbsp;</>}
                {habilitar && <><Button label="Enviar" loading={loading} disabled={loading} icon="pi pi-send" type="button" title="Enviar formulario"
                    className="p-button-warning" onClick={() => enviar()} />&nbsp;</>}
                {habilitar && <><Button loading={loading} disabled={loading} label="Anexos" icon="pi pi-copy" title="Ver Anexos" type="button"
                    className="p-button-warning" onClick={() => subirReporte()} />&nbsp;</>}
            </div>
        </div>
    );
}

export const buttonsBGV = (hideDialog, load, generarReporte, subirReporte, enviar, loading, habilitar = false) => {
    return (
        <div className="formgrid grid">
            <div className="field col-12" style={{ textAlign: 'center' }}>
                {load !== null && <><Button label="Guardar" title="Guardar" type="submit" icon="pi pi-save" className="p-button-warning" loading={load} disabled={load}
                    style={{ width: '130px' }} />&nbsp;</>}
                {habilitar && <><Button label="Formulario" title="Generar Formulario" icon="pi pi-print" type="button" className="p-button-warning" onClick={() => generarReporte()}
                    loading={loading} disabled={loading} style={{ width: '130px' }} />&nbsp;</>}
                {habilitar && <><Button loading={loading} disabled={loading} label="Enviar" title="Enviar formulario" icon="pi pi-send" type="button"
                    className="p-button-warning" onClick={() => enviar()} style={{ width: '130px' }} />&nbsp;</>}
                {habilitar && <><Button label="Anexos" title="Ver Anexos" icon="pi pi-copy" type="button" className="p-button-warning" onClick={() => subirReporte()} style={{ width: '130px' }} />&nbsp;</>}
                {hideDialog && <><Button label="Cancelar" title="Cancelar" icon="pi pi-times" type="button" className="p-button-warning" onClick={() => hideDialog(false)} style={{ width: '130px' }} /></>}
            </div>
        </div>
    );
}

export const downloadPdf = (res, fileName) => {
    const fileURL = window.URL.createObjectURL(
        new Blob([res])
    );
    let fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", fileName);
    document.body.appendChild(fileLink);

    fileLink.click();
    document.body.removeChild(fileLink);
}

export const currentDate = new Date();
export const endOfToday = new Date(); endOfToday.setHours(23, 59, 59, 999);
export const dateFormat = "dd/mm/yy";
export const estadosSiNo = [
    { nombre: 'SI', cat_id: true },
    { nombre: 'NO', cat_id: false }
];

export const stringToDate = (fecha) => {
    if (!fecha || typeof fecha !== 'string') {
        return null;
    }
    const [year, month, day] = fecha.split('-');
    return new Date(+year, month - 1, +day);
}

export const calcularEdad = (fecha) => {
    if (!fecha) return null;
    // Aseguramos que sea un objeto Date (por si viene como String o Timestamp)
    const fechaNac = new Date(fecha);
    // Validamos que sea una fecha válida
    if (isNaN(fechaNac.getTime())) return 0;
    const today = new Date();
    let age = today.getFullYear() - fechaNac.getFullYear();
    const m = today.getMonth() - fechaNac.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < fechaNac.getDate())) {
        age--;
    }
    // Evitamos edades negativas si eligen una fecha futura
    return age < 0 ? 0 : age;
};

export const dateToString = (fecha) => {
    if (!fecha || !(fecha instanceof Date) || isNaN(fecha)) {
        return null;
    }
    return fecha.toISOString().split('T')[0];
}

export const handleKeyDown = (event) => {
    const charCode = event.which || event.keyCode;

    // Allow backspace, tab, enter, escape, delete, arrows, and decimal point
    if (
        [8, 9, 13, 27, 46, 110, 190].includes(charCode) || // Backspace, Tab, Enter, Escape, Delete, Numpad Decimal, Period
        (charCode >= 35 && charCode <= 40) // Arrow keys, Home, End
    ) {
        return;
    }

    // Prevent non-numeric keys
    if ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
        event.preventDefault();
    }

    // Allow only one decimal point
    const value = event.target.value;
    if ((charCode === 110 || charCode === 190) && value.includes('.')) {
        event.preventDefault();
    }

    // Restrict to two decimal places
    const decimalPosition = value.indexOf('.');
    if (decimalPosition !== -1 && value.length - decimalPosition > 2) {
        event.preventDefault();
    }
};

export const accionesTbl = (rowData, setReg, menuRef) => {
    return (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" onClick={(event) => { setReg(rowData); menuRef.current.toggle(event); }} />
    );
}

export const resetAriaHidden = () => {
    const elements = document.querySelectorAll('a[aria-hidden="true"]');
    elements.forEach(el => el.removeAttribute('aria-hidden'));
}

export const validateCedula = (cedula) => {
    // Check if the cedula has exactly 10 digits
    if (!/^\d{10}$/.test(cedula)) {
        return false;
    }

    const provinceCode = parseInt(cedula.substring(0, 2), 10);
    const thirdDigit = parseInt(cedula[2], 10);

    // Province code must be between 01 and 24
    if (provinceCode < 1 || provinceCode > 24) {
        return false;
    }

    // The third digit must be 0, 1, 2, 3, 4, 5, or 6
    if (thirdDigit > 6) {
        return false;
    }

    // Calculate the verification digit
    const coefficients = [2, 1, 2, 1, 2, 1, 2, 1, 2];
    let sum = 0;

    for (let i = 0; i < 9; i++) {
        let digit = parseInt(cedula[i], 10) * coefficients[i];
        if (digit >= 10) {
            digit -= 9;
        }
        sum += digit;
    }

    const mod = sum % 10;
    const checkDigit = mod === 0 ? 0 : 10 - mod;

    // Check if the verification digit matches
    return checkDigit === parseInt(cedula[9], 10);
}

export const validateRuc = (ruc) => {
    // Check if the RUC has exactly 13 digits
    if (!/^\d{13}$/.test(ruc)) {
        return false;
    }

    const thirdDigit = parseInt(ruc[2], 10);

    // Natural persons RUC (starts with a valid cedula and ends with 001)
    if (thirdDigit >= 0 && thirdDigit <= 5) {
        const cedula = ruc.substring(0, 10);
        if (!validateCedula(cedula)) {
            return false;
        }
        // Must end with 001
        return ruc.substring(10, 13) === '001';
    }

    // Legal entities RUC (third digit is 9)
    if (thirdDigit === 9) {
        return validateRucForJuridicalEntity(ruc);
    }

    // Foreigners RUC (third digit is 6)
    if (thirdDigit === 6) {
        return validateRucForPublicEntity(ruc);
    }

    return false;
}

// Helper function to validate juridical entity RUC
export const validateRucForJuridicalEntity = (ruc) => {
    const coefficients = [4, 3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < 9; i++) {
        sum += parseInt(ruc[i], 10) * coefficients[i];
    }

    const mod = sum % 11;
    const checkDigit = mod === 0 ? 0 : 11 - mod;

    return checkDigit === parseInt(ruc[9], 10) && ruc.substring(10, 13) === '001';
}

// Helper function to validate public entity RUC
export const validateRucForPublicEntity = (ruc) => {
    const coefficients = [3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < 8; i++) {
        sum += parseInt(ruc[i], 10) * coefficients[i];
    }

    const mod = sum % 11;
    const checkDigit = mod === 0 ? 0 : 11 - mod;

    return checkDigit === parseInt(ruc[8], 10) && ruc.substring(9, 13) === '0001';
}

export const limpiarNombre = (nombre) =>
    nombre.replace(/[^a-zA-Z0-9 ñÑáéíóúÁÉÍÓÚ\-_.]/g, '_');

/**
* Calcula el número total de días incluyendo extremos
*
* Ejemplo:
*  - inicio = 2025-09-01
*  - fin = 2025-09-03
*
*  Resultado: 3 días (1, 2 y 3 de septiembre)
*
* @param {Date} inicio - Fecha inicial del rango
* @param {Date} fin - Fecha final del rango
* @returns {number} Número de días entre fechas
*/
export const fechasDiferenciaEnDias = (inicio, fin) => {
    if (!inicio || !fin) return 0;
    return differenceInCalendarDays(fin, inicio) + 1;
};

/**
* Calcula el color de texto que contraste (negro o blanco)
* para un color de fondo hexadecimal dado.
*
* @param {string} hex - Color de fondo en formato hexadecimal (#RRGGBB)
* @returns {string} '#fff' si el fondo es oscuro, '#000' si el fondo es claro
*/
export const getContrastTextColor = (hex) => {
    const h = hex.replace(/^#/, '');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    const [R, G, B] = [r, g, b].map(c => {
        const channel = c / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    });
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    const contrastWhite = 1.05 / (L + 0.05);
    const contrastBlack = (L + 0.05) / 0.05;
    return contrastWhite > contrastBlack ? '#fff' : '#000';
};

/**
 * Calcula el valor mínimo y máximo (distinto de cero)
 * dentro de un arreglo de objetos que contienen una propiedad `value`.
 *
 * @param {Array<{ value: number }>} data - Arreglo de objetos con una propiedad numérica `value`.
 * @returns {{ min: number|null, max: number|null }}
 * Objeto con los valores mínimo y máximo encontrados.
 */
export const getMinMaxValue = (data) => {
    const values = data.map(item => Number(item.value)).filter(value => value && !isNaN(value));
    if (values.length === 0) return { min: null, max: null };
    let min = Math.min(...values);
    let max = Math.max(...values);
    if (min === max) min = 0;
    if (min === 0 && max === 0) max = 1;
    return { min, max };
};

export const sanitizarNombreArchivo = (nombreBase) => {
    if (!nombreBase) return 'Reporte_Generado';
    let limpio = String(nombreBase)
        // Normalizar Unicode (Junta caracteres combinados. Ej: 'n' + '~' se vuelve una verdadera 'ñ')
        .normalize('NFC')
        // Eliminar caracteres de control invisibles (ASCII 0-31 y 127) como saltos de línea (\n), tabs (\t), ignoramos estlint.
        // eslint-disable-next-line no-control-regex
        .replace(/[\x00-\x1F\x7F]/g, '')
        // Eliminar caracteres prohibidos por los Sistemas Operativos
        .replace(/[<>:"/\\|?*]/g, '')
        // Convertir cualquier tipo de espaciado (incluso espacios irrompibles) en un solo espacio normal
        .replace(/\s+/g, ' ')
        // Eliminar puntos al inicio o al final (Windows da error si un archivo termina en un punto como "nombre..pdf")
        .replace(/^\.+|\.+$/g, '')
        // Limpiar espacios en los extremos
        .trim();
    // En Windows está prohibido crear archivos que se llamen exactamente así:
    const nombresReservados = /^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])$/i;
    if (nombresReservados.test(limpio)) {
        limpio = `${limpio}_doc`; // Si alguien se llama "Con", será "Con_doc", si no se coloca, Windows devuelve "_Con"
    }
    // Controlar la longitud máxima
    // Lo limitamos a 200 caracteres para dejar espacio de sobra a la extensión (ej. .pdf o .xlsx).
    if (limpio.length > 200) {
        limpio = limpio.substring(0, 200).trim();
    }
    return limpio || 'Reporte_Generado';
}
export const VALIDACION_EMAIL = {
    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    message: 'Correo electrónico no válido'
};
/**
 * Genera un ID HTML seguro a partir de un prefijo y un valor arbitrario.
 *
 * @param {string} prefix - Prefijo descriptivo del contexto (ej: 'tooltip-ac', 'tooltip-chip')
 * @param {string|number} value - Valor base del ID, típicamente el `value` o `label` de la opción
 * @returns {string} ID sanitizado listo para usar en atributos `id` y selectores CSS (ej: 'tooltip-ac-nombre-opcion')
 *
*/
export const toHtmlId = (prefix, value) => `${prefix}-${String(value).normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9-_]/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "")}`;

/**
 * Valida si una identificación (Cédula o RUC) de Ecuador es válida.
 * Sigue la lógica oficial de validación basada en coeficientes y dígitos verificadores.
 *
 * @param {string} identificacion - El número de identificación a validar.
 * @param {'IDEN_CEDULA'|'IDEN_RUC'} tipo - El tipo de documento de identidad.
 * @returns {boolean} Retorna true si la identificación es válida, de lo contrario false.
 */
export const validarIdentificacionEcuador = (identificacion, tipo) => {
    if (typeof identificacion !== 'string') {
        return false;
    }

    const idLimpiada = identificacion.trim();
    const longitud = idLimpiada.length;

    // Verificar que contenga solo dígitos
    if (!/^[0-9]+$/.test(idLimpiada)) {
        return false;
    }

    // Validar longitudes específicas por tipo
    if (tipo === 'IDEN_CEDULA' && longitud !== 10) {
        return false;
    }

    if (tipo === 'IDEN_RUC') {
        if (longitud !== 13) {
            return false;
        }
        // Validar que los últimos tres dígitos del RUC sean mayores o iguales a 001
        const establecimiento = parseInt(idLimpiada.substring(10, 13), 10);
        if (establecimiento < 1) {
            return false;
        }
    }

    // Validar código de provincia (primeros dos dígitos)
    const provincia = parseInt(idLimpiada.substring(0, 2), 10);
    if (provincia < 1 || (provincia > 24 && provincia !== 30)) {
        return false;
    }

    const tercerDigito = parseInt(idLimpiada.substring(2, 3), 10);

    // CASO 1: PERSONA NATURAL (Cédula o RUC de Persona Natural)
    if (tercerDigito < 6) {

        const coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];
        const verificador = parseInt(idLimpiada.substring(9, 10), 10);
        let suma = 0;

        for (let i = 0; i < 9; i++) {
            let residuo = parseInt(idLimpiada.charAt(i), 10) * coeficientes[i];
            if (residuo >= 10) {
                residuo -= 9;
            }
            suma += residuo;
        }

        const residuoSuma = suma % 10;
        const digitoCalculado = residuoSuma === 0 ? 0 : 10 - residuoSuma;

        return verificador === digitoCalculado;
    }

    // CASO 2: ENTIDAD PÚBLICA (RUC) - Sin módulo 11
    if (tercerDigito === 6 && tipo === 'IDEN_RUC') {
        return true;
    }

    // CASO 3: EMPRESA PRIVADA (RUC) - Sin módulo 11
    if (tercerDigito === 9 && tipo === 'IDEN_RUC') {
        return true;
    }

    // Cualquier otro caso no contemplado es inválido
    return false;
};


/**
 * Genera una regla de validación de teléfono dinámica basada en el país seleccionado.
 * 
 * @param {function} getValues - Función de react-hook-form para leer otros campos.
 * @param {string} nombreCampoPais - El `name` del dropdown de país en el formulario.
 * @param {Array} catalogoPaises - El array de países que viene del backend.
 * @returns {function} Función de validación para react-hook-form.
 */
export const validarTelefonoDinamico = (getValues, nombreCampoPais) => {
    return (val) => {
        if (!val) return true;
        // 1. Obtenemos el valor guardado en el form (PrimeReact guarda el OBJETO, no solo el ID)
        const paisValorForm = getValues(nombreCampoPais);
        // 2. Ojo, el catalogo debe tener el nemonico para que al seleccionar el valor lo use
        const codigoIso = paisValorForm?.nemonico || 'EC';
        // 3. Validamos con la librería
        const esValido = isValidPhoneNumber(val, codigoIso);
        return esValido || 'Número de teléfono inválido para el país seleccionado';
    };
};

export const Generico = () => {

    return {
        buttonsForms,
        funcError,
        funcErrorHibrida,
        funcSistemaError,
        funcDeleteError,
        funcMessageBlobError,
        leftToolbarTemplate,
        funDefault,
        getFormErrorMessage,
        paramLazy,
        currentDate,
        endOfToday,
        dateFormat,
        funcSuccess,
        stringToDate,
        renewValues,
        buttonsFormsReports,
        downloadPdf,
        calcularEdad,
        dateToString,
        handleKeyDown,
        estadosSiNo,
        buttonsBGV,
        accionesTbl,
        resetAriaHidden,
        validateCedula,
        validateRuc,
        limpiarNombre,
        fechasDiferenciaEnDias,
        getContrastTextColor,
        getMinMaxValue,
        sanitizarNombreArchivo,
        toHtmlId
    }
}
